module.exports = __webpack_public_path__ + "img/no-gps-heading.2a636bd4.svg";